import { Col, Row } from "react-bootstrap";
import { compose, pure, withHandlers, withState } from "recompose";

import CurrencySpan from "../../Currency/CurrencySpan";
import CustomDatetime from "../../../elements/CustomDatetime/CustomDatetime";
import React from "react";
import ShortenedText from "../../../elements/Text/ShortenedText";
import { fixDateToDataBase } from "../../../tools/formatDate";
import { injectIntl } from "react-intl";
import moment from "moment";

const dateSelectedState = withState("dateSelected", "setDateSelected", false);

const PaymentAffectationDataRecap = ({
  payment,
  intl,
  dateSelected,
  setDateSelected,
  dateState,
  setDateState
}) => {
  const locale = `${intl.locale.split("-")[0]}`;
  if (locale !== "en")
    // en is enabled by default already
    import(`moment/locale/${locale}`);

  let textColor = "Inherit";
  if (payment && payment.providerTransaction === null) textColor = "LightGrey";

  return (
    <Row>
      <Col xs={2}>
        {!!dateSelected && (
          <CustomDatetime
            // open={true}
            onChange={e => {
              const fd = fixDateToDataBase(e);
              setDateState(fd);
            }}
            inputProps={{
              // disabled: !editMode,
              onClick: e => e.target.select()
            }}
            locale={locale}
            defaultValue={moment(dateState)}
          />
        )}
        {!!!dateSelected && (
          <div
            className="space-between affectation-data-recap"
            onClick={() => {
              setDateSelected(true);
            }}
          >
            <p
              className="overflow-ellipsis text-center full-width"
              style={{ color: textColor }}
            >
              {moment(dateState).format("L")}
            </p>
          </div>
        )}
      </Col>
      <Col xs={2}>
        <p className="overflow-ellipsis text-center full-width"
          style={{ color: textColor }}>
          {payment.modePaiement}
        </p>
      </Col>
      <Col xs={3}>
        <p style={{ color: textColor }}>
          <ShortenedText
            shortText={payment.libelleCourt}
            longText={(payment.libelleLong < payment.libelleCourt) ? payment.libelleCourt : payment.libelleLong}
            // longText={payment.libelleLong}
          />
        </p>
        {/* <p
          className="overflow-ellipsis text-center full-width"
          style={{ color: textColor }}
        > */}
        {/* <ShortenedText
            shortText={payment.libelleCourt}
            longText={payment.libelleLong}
          /> */}
        {/* </p> */}
      </Col>
      <Col xs={3}>
        <div className="overflow-ellipsis text-center full-width">
          <CurrencySpan
            textColor={payment.amount < 0 ? "text-danger" : "text-success"}
            currencyId={payment.bankAccount.currency.id || ""}
            value={Math.abs(payment.amount)}
          />
        </div>
        <p className="overflow-ellipsis text-center full-width"
          style={{ color: textColor }}>
          {payment.bankAccount.name}
        </p>
      </Col>
    </Row>
  );
};

export default injectIntl(
  compose(dateSelectedState)(PaymentAffectationDataRecap)
);
